/**
 * Created by nikesh on 9/8/2017.
 */

angular
    .module('eAccess.ProviderPortal.Services.CannotDeactivateAll', []);

